import { useCallback } from 'react'

import { useGamificationDataStore } from '@/shared/store/gamificationDataStore'
import { useUserProgress } from '@/shared/hooks/useUserProgress'
import type { CsatCampaign, CsatSubmission } from '@/types/csat'

import { decideForCompletion } from './decide'
import { useCsatStore } from './store'

/**
 * Hook imperativo para disparar CSAT ao concluir (ou re-concluir) um Level.
 * Não depende do diff do watcher — pode ser chamado a qualquer momento.
 */
export const useCsatTrigger = () => {
  const data = useGamificationDataStore(state =>
    state.activeDigitalProductId
      ? state.dataByProductId[state.activeDigitalProductId]
      : undefined
  )
  const { userProgress } = useUserProgress()
  const { setActivePrompt, isDismissed } = useCsatStore()

  const campaigns: CsatCampaign[] = data?.csat_campaigns ?? []
  const submissions: CsatSubmission[] = userProgress?.csat_submissions ?? []

  const triggerForLevel = useCallback(
    (levelId: number) => {
      const prompt = decideForCompletion({
        campaigns,
        submissions,
        type: 'Level',
        id: levelId,
        isDismissed
      })
      if (prompt) setActivePrompt(prompt)
    },
    [campaigns, submissions, isDismissed, setActivePrompt]
  )

  return { triggerForLevel }
}
